import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import { featuredProjects } from '../../../Assests/assests.js';

const ProjectPreviewGrid = () => {
  const [hoveredProject, setHoveredProject] = useState(null);



  return (
    <section id="ProjectHanger" className="py-20 bg-gradient-to-br from-deep-space via-slate-900 to-slate-800 ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-brand-surface rounded-full px-4 py-2 mb-4">
            <Icon name="Folder" size={16} className="text-rocket-fire" />
            <span className="text-deep-space text-sm font-medium">Featured Projects</span>
          </div>

          <h2 className="text-3xl sm:text-4xl  text-white font-headline text-deep-space mb-4">
            Project Hangar
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Explore my latest projects showcasing full-stack development,
            modern frameworks, and innovative problem-solving approaches.
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {featuredProjects?.map((project) => (
            <div
              key={project?.id}
              className="group relative bg-white rounded-2xl shadow-brand hover:shadow-brand-lg transition-brand overflow-hidden border border-border"
              onMouseEnter={() => setHoveredProject(project?.id)}
              onMouseLeave={() => setHoveredProject(null)}
            >
              {/* Project Image */}
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={project?.image}
                  alt={project?.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-brand"
                />

                {/* Status Badge */}
                <div className="absolute top-4 left-4">
                  <div className={`inline-flex items-center space-x-1 px-3 py-1 rounded-full text-xs font-medium ${project?.status === 'Live' ? 'bg-trust-green text-white' : 'bg-rocket-fire text-white'
                    }`}>
                    <div className={`w-2 h-2 rounded-full ${project?.status === 'Live' ? 'bg-white' : 'bg-white animate-pulse'
                      }`}></div>
                    <span>{project?.status}</span>
                  </div>
                </div>

                {/* Category Badge */}
                <div className="absolute top-4 right-4">
                  <div className="bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-medium text-deep-space">
                    {project?.category}
                  </div>
                </div>

                {/* Hover Overlay */}
                <div className={`absolute inset-0 bg-deep-space/80 backdrop-blur-sm flex items-center justify-center space-x-4 transition-brand ${hoveredProject === project?.id ? 'opacity-100' : 'opacity-0'
                  }`}>
                  <a href={`${project.liveDemo}`}><Button
                    variant="default"
                    size="sm"
                    className="bg-white text-deep-space hover:bg-white/90"
                    iconName="ExternalLink"
                    iconPosition="right"
                  >
                    Live Demo
                  </Button></a>
                  <a href={`${project.github}`}><Button
                    variant="outline"
                    size="sm"
                    className="border-white text-white hover:bg-white/10"
                    iconName="Github"
                    iconPosition="left"
                  >
                    Code
                  </Button></a>
                </div>
              </div>

              {/* Project Content */}
              <div className="p-6">
                <h3 className="text-xl font-value-prop text-deep-space mb-2 group-hover:text-rocket-fire transition-brand">
                  {project?.title}
                </h3>
                <p className="text-text-secondary mb-4 line-clamp-2">
                  {project?.description}
                </p>

                {/* Tech Stack */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {project?.techStack?.slice(0, 4)?.map((tech, index) => (
                    <span
                      key={index}
                      className="inline-flex items-center px-2 py-1 bg-brand-surface text-deep-space text-xs font-medium rounded-md"
                    >
                      {tech}
                    </span>
                  ))}
                  {project?.techStack?.length > 4 && (
                    <span className="inline-flex items-center px-2 py-1 bg-brand-surface text-text-secondary text-xs font-medium rounded-md">
                      +{project?.techStack?.length - 4} more
                    </span>
                  )}
                </div>

                {/* Project Links */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <a href={`${project.liveDemo}`}><button className="flex items-center space-x-1 text-text-secondary hover:text-rocket-fire transition-brand">
                      <Icon name="ExternalLink" size={16} />
                      <span className="text-sm">Demo</span>
                    </button>
                    </a>
                    <a href={`${project.github}`}><button className="flex items-center space-x-1 text-text-secondary hover:text-deep-space transition-brand">
                      <Icon name="Github" size={16} />
                      <span className="text-sm">Code</span>
                    </button>
                    </a>
                  </div>

                  <button className="flex items-center space-x-1 text-rocket-fire hover:text-rocket-fire/80 transition-brand">
                    <span className="text-sm font-medium">Learn More</span>
                    <Icon name="ArrowRight" size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View All Projects CTA */}
        <div className="text-center">
          <a href="https://github.com/LokendraKumar8?tab=repositories"><Button
            variant="outline"
            size="lg"
            className="border-rocket-fire text-rocket-fire hover:bg-rocket-fire hover:text-white"
            iconName="FolderOpen"
            iconPosition="left"
          >
            View All Projects
          </Button></a>
        </div>
      </div>
    </section>
  );
};

export default ProjectPreviewGrid;